import { AssetGroups } from '../constants/assetGroups';

export function computeGroupSummary(rows, group, currencyInfo) {
  const { currencyRates, aggregationCurrency } = currencyInfo;
  const groupMap = new Map();
  for (const row of rows) {
    const key = group === AssetGroups.INDIVIDUAL ? row[0]   // name
              : group === AssetGroups.CURRENCY   ? row[2]   // currency
              :                                    row[1];  // type
    const rowCurrency = row[2];
    const balance = parseFloat(row[3]);
    if (!currencyRates[rowCurrency] || !currencyRates[aggregationCurrency]) continue;
    const aggBalance = balance * parseFloat(currencyRates[aggregationCurrency]) / parseFloat(currencyRates[rowCurrency]);
    groupMap.set(key, (groupMap.get(key) || 0) + aggBalance);
  }
  return Array.from(groupMap).sort((a, b) => b[1] - a[1]);
}
